import React from "react"
import { Link } from "gatsby"
import * as eyeCandyStyles from "./eye-candy.module.scss"
import Seo from "../components/seo"

const EyeCandy = () => {
  return (
    <div className={eyeCandyStyles.wrapper}>
      <Seo
        title="Welcome, Eye Candy Patients"
        description="Eye Candy has closed its doors, and Modern Eye is now the custodian of their patient records. Continue your care with us at University City or Center City, or have your records sent to the provider of your choosing."
      />
      <div aria-hidden="true" className={eyeCandyStyles.redLine}></div>
      <div className={eyeCandyStyles.pageWrapper}>
        <h1 className={eyeCandyStyles.pageTitle}>
          Welcome, Eye Candy Patients
        </h1>
        <div className={eyeCandyStyles.content}>
          <p>
            Our neighbors at Eye Candy have closed their doors for good, and
            Modern Eye is honored that they entrusted us with the care of their
            patients. We are now the official custodian of all Eye Candy
            patient records.
          </p>
          <p>If you were an Eye Candy patient, welcome. We'd love to meet you.</p>
          <h2>What This Means for You</h2>
          <p>
            Your records didn't disappear when Eye Candy closed. Your exam
            history, prescriptions, and patient file are safe with us, and you
            have options:
          </p>
          <ul>
            <li>
              <strong>Continue your care with Modern Eye.</strong> We'd be
              delighted to welcome you at either of our two Philadelphia
              locations, University City or Center City. Your records are
              already here, so picking up right where you left off is easy.
              From comprehensive eye exams to one of the city's best selections
              of independent eyewear, we've got you covered.
            </li>
            <li>
              <strong>Transfer your records anywhere you choose.</strong>{" "}
              Prefer another provider? No problem. We're happy to send your
              file to you or to the office of your choosing, in whatever way
              works best for them.
            </li>
          </ul>
          <p>Either way, just give us a call and we'll take it from there.</p>
        </div>
        <h2 className={eyeCandyStyles.locationsHeader}>Get in Touch</h2>
        <div className={eyeCandyStyles.locationsGrid} role="group">
          <div className={eyeCandyStyles.locationCard}>
            <h3>Modern Eye University City</h3>
            <address>
              3419 Walnut St. <br />
              The Shops at Penn <br />
              Philadelphia, PA 19104
            </address>
            <a href="tel:215-386-5953" title="Call Modern Eye University City">
              215-386-5953
            </a>
          </div>
          <div className={eyeCandyStyles.locationCard}>
            <h3>Modern Eye Center City</h3>
            <address>
              145 South 13th St. <br />
              (NE corner of 13th & Walnut) <br />
              Philadelphia, PA 19107
            </address>
            <a href="tel:215-922-3300" title="Call Modern Eye Center City">
              215-922-3300
            </a>
          </div>
        </div>
        <div className={eyeCandyStyles.content}>
          <p>
            Call whichever location is more convenient. Our team can answer
            questions about your records, schedule an appointment, or start a
            records transfer.
          </p>
          <p>
            We know it's hard to lose an eye care team you've come to trust.
            We'll do everything we can to make this transition an easy one, and
            we hope to see you soon.
          </p>
        </div>
        <Link
          className={eyeCandyStyles.locationsLink}
          to="/locations"
          title="Find Us"
        >
          <span className={eyeCandyStyles.locationsButton}>Find Us</span>
        </Link>
      </div>
    </div>
  )
}

export default EyeCandy
